var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useEffect, useState } from 'react';
import { HashRouter, MemoryRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import "./translationService";
import { configureStore, getStoreKey } from "./store/reducers";
import { getInitialEntities, getInitialData } from './store/actions/response.actions';
import { loadState } from './store/store-helpers';
import { MAIN_CONTAINER } from "./classConstants";
import { CourseAccordionWrapped, CoursesWrapped, CourseTableWrapped } from './components/Courses/Courses';
import { WsRouter } from './WsRouter';
import { AdminRouter } from './AdminRouter';
import { FlashNotifications } from './components/Notification/FlashNotifications';
import { getResponseManager } from './responseManager/BeeResponseManager';
import { addPageScript, getClassName, useIntegrationName, CustomTitleRenderer } from './helpers';
import { BrowserNotSupported } from './components/BrowserNotSupported/BrowserNotSupported';
import { OverlayLoader } from './components/Loader/OverlayLoader';
import { AddToCart, CartPreview } from './components/Cart';
import { Theme } from './Theme';
import { useLocalStorageListener } from './helpers/customEvents';
import { useBookNowListener, useCartListener, useCustomerIdListener } from './components/Cart/cart.helpers';
import get from 'lodash/get';
import omit from 'lodash/omit';
import set from 'lodash/set';
import { API_METHODS_ENUM } from './httpService';
import { LoaderState } from './store/actions/loader.actions';
import { Loader } from './components/Loader/Loader';
import { GlobalEventsComponent } from './components/GlobalEventsComponent';
import { ErrorBoundary } from './components/ErrorBoundary';
import { connect } from './store/connect';
import { getOptions } from './store/stateGetter';
import { AdminBookingForm } from './components/AdminBookingForm/AdminBookingForm';
import { useAppContext, useConfig } from './AppContext';
import { AppInPopup, AppInPopupButton } from './components/AppInPopup';
import { AuthScreen } from './Auth';
import { FloatingUserButtons } from './components/UserButtons/UserButtons';
import { withPoweredBy } from "./components/PoweredBy";
export var PUBLIC_SELECTORS = ["WSCOURSELIST", "WSCOURSETABLE", "WSCOURSEACCORDION", "WSBOOKCART", "WSROOT", "WSADDTOCART", "WSPOPUPFORM", "WSPOPUPBUTTON", "WSCARTPREVIEW", "WSUSER", "WSUSERPREVIEW",];
var PRIVATE_SELECTORS = ["WSADMINBOOKINGFORM", "WSADMINROOT", "WSGLOBALEVENTS", 'WSUSERPREVIEWFLOATING'];
;
export var page_components = {
    WSCOURSELIST: {
        loadable: true,
        Router: HashRouter,
        Render: CoursesWrapped,
    },
    WSCOURSETABLE: {
        loadable: true,
        Router: HashRouter,
        Render: CourseTableWrapped,
    },
    WSCOURSEACCORDION: {
        loadable: true,
        Router: HashRouter,
        Render: CourseAccordionWrapped,
    },
    WSBOOKCART: {
        loadable: true,
        Router: HashRouter,
        Render: WsRouter,
    },
    WSROOT: {
        emitCart: true,
        loadable: true,
        Router: HashRouter,
        customTitle: true,
        Render: WsRouter,
    },
    WSADDTOCART: {
        emitCart: true,
        showNotifications: false,
        Router: MemoryRouter,
        Render: AddToCart,
    },
    WSADMINBOOKINGFORM: {
        emitCart: true,
        loadable: true,
        showNotifications: false,
        public: false,
        Router: HashRouter,
        Render: AdminBookingForm,
    },
    /**
     *
     * @deprecated cart preview floating and cart preview inline have been deprecated.
     * in a next major version, these will be dropped
     *
     */
    WSCARTPREVIEW: {
        showNotifications: false,
        Router: MemoryRouter,
        customTitle: true,
        Render: CartPreview,
    },
    WSUSERPREVIEWFLOATING: {
        showNotifications: false,
        Router: MemoryRouter,
        customTitle: true,
        public: false,
        Render: FloatingUserButtons,
    },
    WSUSERPREVIEW: {
        showNotifications: false,
        Router: MemoryRouter,
        customTitle: true,
        Render: FloatingUserButtons,
    },
    WSADMINROOT: {
        emitCart: true,
        public: false,
        Router: HashRouter,
        Render: AdminRouter,
    },
    WSGLOBALEVENTS: {
        showNotifications: false,
        public: false,
        Render: GlobalEventsComponent,
    },
    WSPOPUPFORM: {
        emitCart: true,
        showNotifications: false,
        Router: MemoryRouter,
        Render: AppInPopup
    },
    /**
     *
     * @deprecated this component is never utilized;
     * Maybe remove this one.
     *
     */
    WSPOPUPBUTTON: {
        showNotifications: false,
        Render: function (props) { return React.createElement(AppInPopupButton, __assign({}, props)); }
    },
    WSUSER: {
        Router: HashRouter,
        Render: withPoweredBy(AuthScreen, true),
    },
};
var getPageComponent = function (componentType) {
    var renderableComponent = componentType || 'WSROOT';
    var _a = page_components[renderableComponent], _b = _a.Router, Router = _b === void 0 ? Fragment : _b, rest = __rest(_a, ["Router"]);
    return __assign(__assign({}, rest), { Router: Router });
};
var Main = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.ws-container-wsglobalevents{\n    position: absolute;\n    pointer-events: none;\n  }\n"], ["\n  &.ws-container-wsglobalevents{\n    position: absolute;\n    pointer-events: none;\n  }\n"])));
var AppComponent = (function () {
    var mapStateToProps = function (state) {
        var _a;
        return {
            initialData: (_a = getInitialData(state.responseReducer)) === null || _a === void 0 ? void 0 : _a.response,
            loader: state.loaderReducer
        };
    };
    var mergeProps = function (_a, dispatchProps, ownProps) {
        var initialData = _a.initialData, loader = _a.loader;
        var loaderState = new LoaderState(loader, {
            keys: [
                API_METHODS_ENUM.GET_INITIAL_ENTITIES,
            ]
        });
        var mergedProps = __assign(__assign({ initialData: initialData }, ownProps), { additional_js: "", hasErrored: loaderState.hasErrored(), isLoading: loaderState.isLoading() || !loaderState.hasLoaded() });
        if (initialData) {
            mergedProps.additional_js = get(getResponseManager(initialData).options(), "additional_js", "");
        }
        return mergedProps;
    };
    var EventManager = function (_a) {
        var shouldEmit = _a.shouldEmit;
        // Add cart event listeners
        useCartListener(undefined, { noEmit: !shouldEmit });
        useBookNowListener();
        useCustomerIdListener();
        return null;
    };
    var App = function (props) {
        var index = props.index, componentType = props.componentType, name = props.name, attributes = props.attributes;
        var _a = getPageComponent(componentType), Render = _a.Render, _b = _a.emitCart, emitCart = _b === void 0 ? false : _b, _c = _a.loadable, loadable = _c === void 0 ? false : _c, _d = _a.showNotifications, showNotifications = _d === void 0 ? true : _d;
        var formName = name || "form-" + index;
        var filterPrefix = "wsc_" + (index >= 0 ? (index + 1) : name);
        // const hideLoader = ["WSADMINROOT"].includes(componentType?.toUpperCase() as string);
        // const showNotifications = shouldAddNotifications(componentType);
        var integrationName = useIntegrationName();
        var componentProps = {
            filterPrefix: filterPrefix,
            name: formName,
            attributes: attributes,
            integrationName: integrationName,
            showPopup: props.showPopup,
            onModalClose: props.onModalClose,
            children: props.children,
            bookingFormRef: props.bookingFormRef,
        };
        var renderChildComponent = function () {
            /**
             *
             * @deprecated props.component should not be used.
             * investigate and remove this behavior.
             *
             */
            if (props.component) {
                var Component = props.component;
                return React.createElement(Component, __assign({}, componentProps));
            }
            ;
            return React.createElement(Render, __assign({}, componentProps));
        };
        if (!props.hasErrored && !loadable && props.isLoading)
            return null;
        if (!props.hasErrored && loadable && props.isLoading)
            return React.createElement(Loader, null);
        if (!loadable && props.hasErrored)
            return !showNotifications ? null : (React.createElement(Theme, { className: getClassName(formName, "browserNotSupported") },
                React.createElement(BrowserNotSupported, { hasErrored: props.hasErrored })));
        return (React.createElement(Theme, { className: formName },
            showNotifications && React.createElement(BrowserNotSupported, { className: "browserNotSupported" }),
            showNotifications && React.createElement(FlashNotifications, null),
            renderChildComponent(),
            React.createElement(EventManager, { shouldEmit: emitCart }),
            React.createElement(OverlayLoader, null)));
    };
    return connect(mapStateToProps, null, mergeProps)(App);
})();
var InitializeApp = function () {
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(getInitialEntities());
    }, []);
    return null;
};
var IntegrationManager = function (props) {
    var options = useSelector(getOptions);
    var noAdditionalJS = useConfig("noAdditionalJS")[0];
    // Bind Local Storage Events
    useLocalStorageListener();
    // useToastNotifications();
    var additional_js = !noAdditionalJS ? get(options, "additional_js", "") : "";
    useEffect(function () {
        addPageScript(additional_js);
    }, [additional_js]);
    var customTitle = getPageComponent(props.componentType).customTitle;
    if (!customTitle)
        return null;
    // Adds Custom title
    return React.createElement(CustomTitleRenderer, { hasLoaded: options !== null, componentType: props.componentType });
};
export var App = function (_a) {
    var _b, _c, _d;
    var _e = _a.children, children = _e === void 0 ? null : _e, apiBaseUrl = _a.apiBaseUrl, props = __rest(_a, ["children", "apiBaseUrl"]);
    var persistToSessionStorage = useConfig("disableCart", true)[0];
    var _f = useConfig("bookingForm.showAsWizard"), setShowAsWizard = _f[1];
    var integrationName = props.attributes.integrationName;
    var storeKey = getStoreKey(integrationName, props.name || props.index);
    var showWizard = React.useRef((_b = props.attributes) === null || _b === void 0 ? void 0 : _b.showWizard).current;
    var Router = getPageComponent(props.componentType).Router;
    React.useEffect(function () {
        if (showWizard === undefined) {
            return;
        }
        setShowAsWizard(showWizard !== "false");
    }, [showWizard]);
    var appContext = (_c = useAppContext()) === null || _c === void 0 ? void 0 : _c.config;
    var store = useState(function () { return configureStore(storeKey, loadState(integrationName, storeKey), __assign(__assign({}, appContext), { apiBaseUrl: apiBaseUrl, persistToSessionStorage: persistToSessionStorage })); })[0];
    return React.createElement(Provider, { store: store },
        React.createElement(React.StrictMode, null,
            React.createElement(Router, null,
                React.createElement(Main, { className: getClassName(MAIN_CONTAINER, MAIN_CONTAINER + "-" + ((_d = props.componentType) === null || _d === void 0 ? void 0 : _d.toLowerCase())) },
                    React.createElement(ErrorBoundary, null,
                        React.createElement(InitializeApp, null),
                        React.createElement(IntegrationManager, { componentType: props.componentType }),
                        React.createElement(AppComponent, __assign({}, props)),
                        children)))));
};
export var AdminApp = function (_a) {
    var apiBaseUrl = _a.apiBaseUrl, props = __rest(_a, ["apiBaseUrl"]);
    var integrationName = props.attributes.integrationName;
    var storeKey = getStoreKey(integrationName, props.name || props.index);
    var store = React.useMemo(function () { return configureStore(storeKey, omit(set(loadState(integrationName, storeKey), "courseReducer.pageSize", 50), "cartReducer"), { apiBaseUrl: apiBaseUrl, persistToSessionStorage: false }); }, [storeKey, integrationName, apiBaseUrl]);
    return React.createElement(Provider, { store: store },
        React.createElement(React.StrictMode, null,
            React.createElement(HashRouter, null,
                React.createElement(Main, { className: getClassName(MAIN_CONTAINER, props.className) },
                    React.createElement(InitializeApp, null),
                    React.createElement(AppComponent, __assign({}, props))))));
};
var templateObject_1;
